import { render } from "./P070.vue?vue&type=template&id=d74a12dc&scoped=true"
import script from "./P070.vue?vue&type=script&lang=js"
export * from "./P070.vue?vue&type=script&lang=js"

import "./P070.vue?vue&type=style&index=0&id=d74a12dc&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d74a12dc"]])

export default __exports__